<template>
    <section class="card">
      <div class="container" :style="'background-color: '+card.color_bg+';'">
        <div class="imgContainer" :style="'background-image: url('+card.photo_link+');'"  v-if="card.photo_link!=''"></div>
        <div :class="'textContainer '+textStyle">
          <div class="title" :style="'color:'+this.color_text" v-if="this.color_text!=''">{{ card.name }} </div>
          <div class="title" v-if="this.color_text==''">{{ card.name }} </div>
          <div class="position" v-if="card.position!=''">{{ card.position }} </div>
          <div class="org" v-if="card.org!=''">{{ card.org }} </div>
          <div class="site" v-if="card.site!=''"> <a :href="card.site">{{ card.site }}</a></div>
          <div class="filedBlocks">
            <div class="filedBlock" v-if="card.email!=''">
              <div class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.6">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 4.5C1.25 4.08579 1.58579 3.75 2 3.75H22C22.4142 3.75 22.75 4.08579 22.75 4.5V19.5C22.75 19.9142 22.4142 20.25 22 20.25H2C1.58579 20.25 1.25 19.9142 1.25 19.5V4.5ZM2.75 5.25V18.75H21.25V5.25H2.75Z" :fill="color_icons"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.39998 4.04998C1.64851 3.71861 2.11861 3.65145 2.44998 3.89998L12 11.0625L21.55 3.89998C21.8814 3.65145 22.3515 3.71861 22.6 4.04998C22.8485 4.38135 22.7814 4.85145 22.45 5.09998L12.45 12.6C12.1833 12.8 11.8166 12.8 11.55 12.6L1.54998 5.09998C1.21861 4.85145 1.15145 4.38135 1.39998 4.04998Z" :fill="color_icons"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 4.5C1.25 4.08579 1.58579 3.75 2 3.75H12C12.4142 3.75 12.75 4.08579 12.75 4.5C12.75 4.91421 12.4142 5.25 12 5.25H2.75V12C2.75 12.4142 2.41421 12.75 2 12.75C1.58579 12.75 1.25 12.4142 1.25 12V4.5Z" :fill="color_icons"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 4.5C11.25 4.08579 11.5858 3.75 12 3.75H22C22.4142 3.75 22.75 4.08579 22.75 4.5V12C22.75 12.4142 22.4142 12.75 22 12.75C21.5858 12.75 21.25 12.4142 21.25 12V5.25H12C11.5858 5.25 11.25 4.91421 11.25 4.5Z" :fill="color_icons"/>
</g>
</svg>

              </div>
              <div class="title"><div><a target="_blank" :href="'mailto:'+card.email">{{ card.email }}</a></div></div>
            </div>
            <div class="filedBlock" v-if="card.phone!=''">
              <div class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.6">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.08503 4.49917C5.27886 4.49917 4.77598 5.22156 5.00628 5.90411C5.83205 8.35138 7.37088 12.0329 9.66571 14.3278C11.9605 16.6226 15.6421 18.1614 18.0894 18.9872C18.7719 19.2175 19.4943 18.7147 19.4943 17.9084V15.4235C19.4943 15.3346 19.4462 15.2527 19.3684 15.2094L17.2039 14.006C17.1332 13.9667 17.0477 13.9648 16.9754 14.001L14.6669 15.1552C14.5226 15.2274 14.3585 15.25 14.2 15.2196L14.3384 14.498C14.2 15.2196 14.2002 15.2196 14.2 15.2196L14.1979 15.2192L14.1951 15.2186L14.1877 15.2172L14.1656 15.2126C14.1476 15.2087 14.1232 15.2033 14.093 15.1962C14.0326 15.1819 13.9485 15.1606 13.8449 15.1307C13.6381 15.071 13.3514 14.9765 13.0183 14.8346C12.3549 14.5519 11.489 14.073 10.7047 13.2888C9.92057 12.5046 9.44038 11.6374 9.15637 10.9731C9.01373 10.6395 8.91856 10.3523 8.85831 10.1451C8.82814 10.0413 8.8066 9.95712 8.79215 9.89662C8.78492 9.86636 8.77946 9.84198 8.77558 9.82399L8.77092 9.80185L8.76942 9.79448L8.76888 9.79174L8.76866 9.79061C8.76861 9.79037 8.76847 9.78964 9.48965 9.64936L8.76866 9.79061C8.73772 9.63154 8.76005 9.46574 8.83251 9.3208L9.98687 7.01205C10.023 6.93982 10.0212 6.85431 9.98195 6.78363L8.78374 4.62524C8.78373 4.62523 8.78375 4.62526 8.78374 4.62524C8.74052 4.54743 8.65851 4.49917 8.56961 4.49917H6.08503ZM10.2689 9.73364C10.269 9.73404 10.2692 9.73445 10.2693 9.73486C10.3155 9.89386 10.3915 10.1242 10.5075 10.3955C10.7407 10.9411 11.1278 11.6339 11.7437 12.2497C11.7437 12.2498 11.7437 12.2497 11.7437 12.2497L11.2242 12.7693M11.7437 12.2497C12.3595 12.8655 13.0507 13.2511 13.5943 13.4828C13.8648 13.598 14.0941 13.6732 14.2524 13.7189C14.2527 13.719 14.2521 13.7188 14.2524 13.7189L16.3181 12.6868C16.3181 12.6868 16.3181 12.6868 16.3181 12.6868C16.8245 12.4336 17.4231 12.4467 17.9178 12.7217L20.0824 13.9252C20.6264 14.2276 20.9637 14.8011 20.9637 15.4235V17.9084C20.9637 19.6332 19.3352 20.9584 17.6196 20.3794C15.1416 19.5433 11.1777 17.9178 8.6267 15.3668C6.07568 12.8158 4.45016 8.8519 3.61402 6.37389C3.03515 4.6583 4.36028 3.02979 6.08503 3.02979H8.56961C9.19237 3.02979 9.76612 3.36753 10.0684 3.91197L11.2667 6.07045C11.5412 6.56497 11.5542 7.16316 11.3011 7.66917C11.3011 7.66919 11.3011 7.66915 11.3011 7.66917L10.2689 9.73364" :fill="color_icons"/>
</g>
</svg>

              </div>
              <div class="title"><div><a :href="'tel:+'+card.phone">+{{ card.phone }}</a></div></div>
            </div>
            <div class="filedBlock" v-if="card.facebook!=''">
              <div class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.6">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.7876 14.0196C5.83137 14.0344 5.87555 14.0448 5.91969 14.0512C5.96783 14.1644 6.03002 14.3107 6.10258 14.4818C6.27966 14.8994 6.51825 15.4643 6.76452 16.0535C7.26677 17.2552 7.77338 18.4939 7.88527 18.8485C8.02378 19.2868 8.17019 19.5848 8.33002 19.7883C8.41267 19.8935 8.50825 19.9853 8.62009 20.0549C8.67639 20.0899 8.73587 20.1186 8.79795 20.14C8.80068 20.141 8.80341 20.1419 8.80614 20.1428C9.12616 20.2636 9.41792 20.2133 9.60059 20.1518C9.69833 20.1188 9.77741 20.0791 9.83346 20.0469C9.86204 20.0304 9.88618 20.0151 9.90544 20.0021L9.90998 19.9991L12.7362 18.2366L16.0007 20.7394C16.0489 20.7763 16.1014 20.8073 16.1571 20.8316C16.5493 21.0027 16.929 21.0624 17.2863 21.0136C17.6429 20.9649 17.9261 20.8151 18.1369 20.6464C18.3433 20.4813 18.4832 20.2963 18.5704 20.1589C18.6149 20.0887 18.6483 20.0266 18.6718 19.9791C18.6837 19.9552 18.6932 19.9346 18.7005 19.9181L18.71 19.8963L18.7135 19.8877L18.715 19.8841L18.7157 19.8824L18.7163 19.8808C18.7335 19.8379 18.7466 19.7935 18.7556 19.7482L21.7359 4.72274C21.7454 4.67469 21.7502 4.62581 21.7502 4.57682C21.7502 4.13681 21.5844 3.71841 21.1946 3.46452C20.8614 3.24752 20.4902 3.23818 20.2556 3.25598C20.0026 3.27519 19.7689 3.33766 19.612 3.38757C19.5304 3.41355 19.462 3.43861 19.4127 3.45773C19.3879 3.46734 19.3675 3.47559 19.3524 3.48188L19.341 3.48666L2.62731 10.0432L2.62515 10.044C2.6145 10.0479 2.60082 10.053 2.58457 10.0593C2.55221 10.0719 2.50884 10.0896 2.45819 10.1126C2.35941 10.1574 2.22083 10.2273 2.07862 10.3247C1.85143 10.4803 1.32894 10.9064 1.41692 11.6097C1.48711 12.1708 1.87149 12.5154 2.10568 12.6811C2.23427 12.7721 2.35644 12.8371 2.44541 12.8795C2.48668 12.8991 2.57238 12.9339 2.60956 12.9491L2.61895 12.9529L5.7876 14.0196ZM19.926 4.86786L19.9236 4.86888C19.9153 4.8725 19.9069 4.87596 19.8985 4.87928L3.16446 11.4438C3.15572 11.4472 3.14692 11.4505 3.13806 11.4536L3.12875 11.4571C3.11804 11.4613 3.10002 11.4686 3.0774 11.4788C3.06457 11.4846 3.05118 11.491 3.03753 11.4978C3.05629 11.5084 3.07423 11.5175 3.09018 11.5251C3.10549 11.5324 3.11717 11.5374 3.12356 11.54L6.26619 12.598C6.32371 12.6174 6.37733 12.643 6.42655 12.674L16.8033 6.59948L16.813 6.59374C16.8206 6.58927 16.8305 6.58353 16.8424 6.5768C16.866 6.56345 16.8985 6.54568 16.9371 6.52603C17.0091 6.48938 17.1243 6.43497 17.2541 6.39485C17.3445 6.36692 17.611 6.28823 17.8991 6.38064C18.0769 6.43767 18.261 6.56028 18.3807 6.76798C18.4402 6.87117 18.4719 6.97483 18.4872 7.06972C18.528 7.2192 18.5216 7.36681 18.4897 7.49424C18.4209 7.76875 18.228 7.98287 18.0525 8.14665C17.9022 8.28706 15.9568 10.1629 14.0377 12.0147C13.0806 12.9381 12.1333 13.8525 11.4253 14.5359L10.9602 14.9849L16.8322 19.4867C16.9668 19.5349 17.0464 19.5325 17.0833 19.5274C17.1272 19.5214 17.1631 19.5045 17.1998 19.4752C17.2408 19.4424 17.2767 19.398 17.3035 19.3557L17.3046 19.354L20.1951 4.78102C20.1522 4.79133 20.1088 4.80361 20.067 4.81691C20.0196 4.83198 19.9806 4.84634 19.9547 4.85637C19.9419 4.86134 19.9327 4.86511 19.9277 4.86719L19.926 4.86786ZM11.4647 17.2618L10.2932 16.3636L10.0093 18.1693L11.4647 17.2618ZM9.21852 14.5814L10.3835 13.4567C11.0916 12.7732 12.039 11.8588 12.9961 10.9352L13.9686 9.997L7.44859 13.8138L7.48357 13.8963C7.66127 14.3154 7.90093 14.8827 8.14851 15.4751C8.33364 15.918 8.52723 16.3844 8.70356 16.8162L8.98659 15.0158C9.01388 14.8422 9.09868 14.692 9.21852 14.5814Z" :fill="color_icons"/>
</g>
</svg>

              </div>
              <div class="title"><div><a target="_blank" :href="'https://t.me/'+card.facebook">@{{ card.facebook }}</a></div></div>
            </div>
          </div>
          <div class="raw">
            <div>
              <a :class="'buttonBlack light '+color_button+' '+color_button_text" target="_blank" :href="downloadLink">Скачать визитку</a>
            </div>
            <div>
              <a :class="'buttonBlack '+color_button+' '+color_button_text" :href="vcfLink">Сохранить контакт</a>
            </div>
          </div>
          <div class="homeLinkBox">
              <a :href="homeLink">Создай свою digital-визитку на <span>www.sustainable-card.com</span></a>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import axios from 'axios';
axios.defaults.withCredentials = false;


//this.$route.params.id
export default {
  name: 'MyCard',
  components: {},
  data(){return {
    homeLink: '',
    downloadLink: '',
    vcfLink: '',
    color_bg: '',
    color_text: '',
    color_icons: '',
    color_button: '',
    color_button_text:'', 
    textStyle:'',
    card: {
        id: '',
        code: '',
        name: '',
        org: '',
        position: '',
        phone: '',
        email: '',
        site: '',
        photo_link: '',
        facebook: '',
        color_bg: '',
        color_text: '',
        datetime: 0,
    },
    colorsBlackSelect:[
      '#D9D9D9','#EFEFEF','#F3F3F3','#FFFFFF',
      '#FFFF00','#00FFFF',
      '#F4CCCC','#FCE5CD','#FFF2CC','#D9EAD3','#D0E0E3','#C9DAF8','#CFE2F3','#D9D2E9','#EAD1DC',
      '#FFE599',
    ]
  }},
  beforeCreate : async function () {
    this.homeLink = window.location.origin;
    if(!this.$route.params.id || this.$route.params.id.length<26) return this.$router.push('/404');
    try{
      const result = await axios.get((process.env.NODE_ENV === "production" ? "." : "https://sc.vorobev.pro" ) + "/api/card/get/"+this.$route.params.id, {withCredentials: false});
      if(!result.data.success) return this.$router.push('/404');
      this.card = result.data.card;
      this.downloadLink = (process.env.NODE_ENV === "production" ? "." : "https://sc.vorobev.pro" ) + '/api/card/download/card/'+result.data.card.id;
      this.vcfLink = (process.env.NODE_ENV === "production" ? "." : "https://sc.vorobev.pro" ) + '/api/card/vcf/'+result.data.card.id;
      this.color_bg = result.data.card.color_bg && result.data.card.color_bg!='' ? result.data.card.color_bg: '#FFFFFF';
      this.color_text = result.data.card.color_text && result.data.card.color_text!='' ? result.data.card.color_text: '';
      this.textStyle = this.colorsBlackSelect.includes(this.color_bg) ? 'blackStyle' : 'lightStyle';
      this.color_icons= this.colorsBlackSelect.includes(this.color_bg) ? '#000000' : '#FFFFFF';
      this.color_button=result.data.card.color_text && result.data.card.color_text!='' ? result.data.card.color_text.replace('#', "color_"): this.colorsBlackSelect.includes(this.color_bg) ? 'color_000000' :'color_FFFFFF';
      this.color_button_text = this.colorsBlackSelect.includes(this.color_bg) ? 'text_color_light' : 'text_color_black';
    }catch(e){
      alert('Internal error');
      // return this.$router.push('/404');
    }
  },
  methods: {
    mouseOver: function(n){
        this.activeId = n;   
    },
    open:function(a){
      store.modals.current=a;
    },
    handleScroll: function (evt, el) {
      if(store.page!='home')return;
      var topView= document.querySelector('.view3').offsetTop;
      var hView= document.querySelector('.view3').offsetHeight;
      if(window.scrollY>topView&&window.scrollY<(topView+hView-(hView/10))&&store.modals.current==''){
        document.querySelector('header').classList.add("hide");
      }else{
        document.querySelector('header').classList.remove("hide");
      }
    },
    scrollTo:function(id){
      if(store.modals.current!='')store.modals.current='';
      //console.log('test')
      var elTop=document.getElementById(id).offsetTop;
      //console.log('test',elTop)
      store.workflowHide=true;
      window.scrollTo({top: elTop,left:0,behavior: "smooth"});
      if(this.setTimeoutid>0)clearTimeout(this.setTimeoutid);
      this.setTimeoutid=setTimeout(() => {
        store.workflowHide=false;
      }, 1500);
    },
  },
  mounted(){
    // setTimeout(()=>{
    //   this.frameMenuOn=true;
    //   this.newInterval();
    // },1500);
  },
}
</script>
